import global from '@/assets/js/global'
import axios from 'axios'

const path = 'firestoreSchool/lottery'

/*
 *  LOTTERIES
 */

const get = async (params, token) => {
  const options = {
    params,
    headers: { authorization: token },
  }
  const res = await axios.get(`${global.server}${path}`, options)
  return res.data
}

export default {
  get,
}
